import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { hideEodInvitePopup } from '~/actions';
import { useInfiniteEligibleJobs } from '~/domain/EligibleJobs';
import { getShouldShowRatingInviteToEligibleJobsScreen } from '~/growthbook';
import { IJob, ProfessionTypeEnum } from '~/models';
interface IUseRatingFeedbackSuccessProps {
  averageRating: number;
  job: IJob;
  shouldCheckConditions: boolean;
  onSubmitFeedback: () => void;
  shouldRestorePopup?: boolean;
}

export const useRatingFeedbackSuccess = ({
  averageRating,
  job,
  shouldCheckConditions,
  onSubmitFeedback,
  shouldRestorePopup,
}: IUseRatingFeedbackSuccessProps) => {
  const dispatch = useDispatch();
  const [shouldShowRatingSentPopup, setShouldShowRatingSentPopup] = useState(
    shouldRestorePopup ?? false,
  );
  const hasCheckedRef = useRef(false);

  const { eligibleJobs, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useInfiniteEligibleJobs({
      xOfficeId: job?.offer_owner?.id,
      professionalId: job?.offer_final_reciever?.id,
      limit: 10,
      profession: job?.profession as ProfessionTypeEnum,
      enabled:
        !!job?.offer_owner?.id &&
        !!job?.offer_final_reciever?.id &&
        !!job?.profession &&
        !job?.isOnsiteInterview &&
        getShouldShowRatingInviteToEligibleJobsScreen(),
    });

  const hasEligibleJobs = eligibleJobs && eligibleJobs.length > 0;
  const shouldShowNewPopup = averageRating >= 4 && hasEligibleJobs;

  const handleCloseRatingSentPopup = () => {
    setShouldShowRatingSentPopup(false);
    dispatch(hideEodInvitePopup());
    onSubmitFeedback();
  };

  useEffect(() => {
    if (shouldRestorePopup) return;

    if (shouldCheckConditions && !hasCheckedRef.current) {
      hasCheckedRef.current = true;

      setShouldShowRatingSentPopup(shouldShowNewPopup);

      if (!shouldShowNewPopup) {
        onSubmitFeedback();
      }
    }
  }, [shouldCheckConditions, onSubmitFeedback, shouldShowNewPopup, shouldRestorePopup]);

  return {
    shouldShowRatingSentPopup,
    setShouldShowRatingSentPopup,
    eligibleJobs,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoadingEligibleJobs: isLoading,
    handleCloseRatingSentPopup,
  };
};
